import { motion } from "framer-motion";

const GROUPS = [
  {
    title: "Creative Leadership",
    color: "#FF4D23",
    items: ["Art Direction", "Design Leadership", "Creative Strategy", "Team Mentoring", "Brand Governance", "Cross-functional Collaboration"],
  },
  {
    title: "Design Expertise",
    color: "#00C2FF",
    items: ["Brand Identity", "Campaign Design", "Performance Creative", "Packaging & Print", "E-commerce Design", "Motion & Visual Storytelling"],
  },
  {
    title: "Design Tools",
    color: "#FFB800",
    items: ["Adobe Photoshop", "Adobe Illustrator", "Adobe InDesign", "Adobe After Effects", "Adobe Premiere Pro", "Figma"],
  },
  {
    title: "AI & Emerging Workflows",
    color: "#00E699",
    items: ["ChatGPT", "Adobe Firefly", "Midjourney", "Runway", "Kling", "Seedance", "ElevenLabs", "Gemini"],
  },
];

export default function Skills() {
  return (
    <section id="skills" data-testid="skills-section" className="py-20 lg:py-24 border-t border-[#222634]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="font-mono2 text-xs tracking-[0.3em] uppercase text-[#FF4D23] mb-3">05 · Expertise</p>
        <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight uppercase mb-12" data-testid="skills-heading">
          Skills &amp; <span className="text-[#FF4D23]">Tools</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {GROUPS.map((g, gi) => (
            <motion.div
              key={g.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: gi * 0.1 }}
              className="bg-[#12141B] border border-[#222634] rounded-2xl p-6 hover:border-[#3B4254] transition-colors"
              data-testid={`skills-group-${g.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <div className="flex items-center gap-3 mb-6">
                <span className="w-2.5 h-2.5 rounded-full" style={{ background: g.color }} />
                <h3 className="font-display font-bold text-lg">{g.title}</h3>
              </div>
              <div className="flex flex-wrap gap-2">
                {g.items.map((item) => (
                  <span
                    key={item}
                    className="text-xs font-mono2 tracking-wide text-[#B6BDCB] border border-[#3B4254] rounded-full px-3.5 py-1.5 hover:text-[#F5F6FA] transition-colors cursor-default"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
